import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  sqState: attr(String),
  customState: attr(String),
  unitToken: attr(String)
});